import { useCallback, useEffect, useMemo, useRef } from 'react';
import { createAuthUtils } from '../utils/auth.utils';

export type TokensData = {
	accessToken?: string;
	refreshToken?: string;
};

export const useAuthCookies = (props: { domain: string; prefix?: string; onChange?: (tokens: TokensData) => void; interval?: number }) => {
	const tokensRef = useRef<TokensData>({});

	const syncCookies = useCallback(() => {
		const authUtils = createAuthUtils(props.domain, props.prefix);

		const accessToken = authUtils.getAccessTokenCookie();
		const refreshToken = authUtils.getRefreshTokenCookie();

		const newTokens = {
			accessToken,
			refreshToken,
		};

		if (tokensRef.current?.accessToken !== accessToken || tokensRef.current?.refreshToken !== refreshToken) {
			props?.onChange?.(newTokens);
			tokensRef.current = newTokens;
		}
	}, [props?.onChange, tokensRef.current?.accessToken, tokensRef.current?.refreshToken, props.domain, props.prefix]);

	useEffect(() => {
		syncCookies();

		const intervalId = setInterval(() => {
			syncCookies();
		}, props?.interval ?? 10_000);

		return () => {
			clearInterval(intervalId);
		};
	}, [syncCookies, props?.interval]);

	return useMemo(
		() => ({
			...(tokensRef.current ?? {}),
			syncCookies,
		}),
		[syncCookies, tokensRef.current]
	);
};
